"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var date_fns_1 = require("date-fns");

var React = __importStar(require("react"));

var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");
/**
 * @ignore
 */


var DateWidget =
/** @class */
function (_super) {
  __extends(DateWidget, _super);

  function DateWidget(props) {
    var _this = _super.call(this, props) || this;

    _this.isInRange = function (date) {
      return !date_fns_1.isBefore(date, _this.props.minDate) && !date_fns_1.isAfter(date, _this.props.maxDate);
    };

    _this.setDateOrClosest = function (date) {
      return _this.setState({
        activeDate: _this.isInRange(date) ? date : date_fns_1.closestTo(date, [_this.props.minDate, _this.props.maxDate])
      });
    };

    _this.startOfMonth = function () {
      return _this.setDateOrClosest(date_fns_1.startOfMonth(_this.state.activeDate));
    };

    _this.endOfMonth = function () {
      return _this.setDateOrClosest(date_fns_1.endOfMonth(_this.state.activeDate));
    };

    _this.nextMonth = function () {
      return _this.setDateOrClosest(date_fns_1.addMonths(_this.state.activeDate, 1));
    };

    _this.previousMonth = function () {
      return _this.setDateOrClosest(date_fns_1.subMonths(_this.state.activeDate, 1));
    };

    _this.nextWeek = function () {
      return _this.setDateOrClosest(date_fns_1.addWeeks(_this.state.activeDate, 1));
    };

    _this.previousWeek = function () {
      return _this.setDateOrClosest(date_fns_1.subWeeks(_this.state.activeDate, 1));
    };

    _this.nextDay = function () {
      return _this.setDateOrClosest(date_fns_1.addDays(_this.state.activeDate, 1));
    };

    _this.previousDay = function () {
      return _this.setDateOrClosest(date_fns_1.subDays(_this.state.activeDate, 1));
    };

    _this.preventMouseDown = function (e) {
      e.stopPropagation();
    };

    _this.onClick = function (year, month, day) {
      _this.props.onChange(new Date(year, month, day));
    };

    _this.keyHandler = function (e) {
      var _a;

      utils_1.SelectionNavHelper.useKeyMap(e, (_a = {}, _a[w3c_keys_1.Key.Home] = function () {
        return _this.startOfMonth();
      }, _a[w3c_keys_1.Key.End] = function () {
        return _this.endOfMonth();
      }, _a[w3c_keys_1.Key.ArrowDown] = function () {
        return _this.nextWeek();
      }, _a[w3c_keys_1.Key.ArrowUp] = function () {
        return _this.previousWeek();
      }, _a[w3c_keys_1.Key.ArrowLeft] = function () {
        return _this.previousDay();
      }, _a[w3c_keys_1.Key.ArrowRight] = function () {
        return _this.nextDay();
      }, _a[w3c_keys_1.Key.PageUp] = function () {
        return _this.previousMonth();
      }, _a[w3c_keys_1.Key.PageDown] = function () {
        return _this.nextMonth();
      }, _a[w3c_keys_1.Key.Enter] = function () {
        return _this.onClick(_this.state.activeDate.getFullYear(), _this.state.activeDate.getMonth(), _this.state.activeDate.getDate());
      }, _a));
    };

    _this.onBlur = function (e) {
      if (_this.state.initialDate) {
        _this.props.onChange(_this.state.initialDate);
      } else {
        _this.props.onChange();
      }

      _this.props.onBlur(e);
    };

    _this.state = {
      initialDate: props.value,
      activeDate: props.value || date_fns_1.startOfDay(new Date())
    };
    return _this;
  }

  DateWidget.getDerivedStateFromProps = function (props, state) {
    return props.value !== state.initialDate ? {
      initialDate: props.value,
      activeDate: props.value || date_fns_1.startOfDay(new Date())
    } : null;
  };

  DateWidget.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        value = _a.value,
        onWidgetClick = _a.onWidgetClick,
        refCallback = _a.refCallback;
    var activeDate = this.state.activeDate;
    var daysOfWeek = [0, 1, 2, 3, 4, 5, 6];
    var weeksOfMonth = [0, 1, 2, 3, 4, 5];
    var offsetDay = date_fns_1.getDay(date_fns_1.startOfMonth(activeDate)) - 1;
    var numDaysOfMonth = date_fns_1.getDaysInMonth(activeDate);
    var isSelectedMonth = value && value.getFullYear() === activeDate.getFullYear() && value.getMonth() === activeDate.getMonth();
    return React.createElement("div", {
      tabIndex: 0,
      onKeyDown: this.keyHandler,
      className: CSSPrefix_1.lsgPre + "inputdatepicker-widget",
      onMouseDown: onWidgetClick,
      onTouchStart: onWidgetClick,
      ref: refCallback,
      onBlur: this.onBlur
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-spacer"
    }), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-content"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-yearmonth"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-prev",
      onClick: this.previousMonth
    }, React.createElement(IconLink_1.IconLink, {
      htmlAttrs: {
        tabIndex: -1
      },
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronLeft,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
    }, utils_1.Localization.texts.lsg.component.InputDatepicker.previousMonth)), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-label"
    }, date_fns_1.format(activeDate, "MMMM yyyy", {
      locale: utils_1.DateUtils.getCurrentLocale()
    })), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-next",
      onClick: this.nextMonth
    }, React.createElement(IconLink_1.IconLink, {
      htmlAttrs: {
        tabIndex: -1
      },
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronRight,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
    }, utils_1.Localization.texts.lsg.component.InputDatepicker.nextMonth))), React.createElement("table", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-table"
    }, React.createElement("thead", null, React.createElement("tr", null, utils_1.DateUtils.getLocaleDays("short").map(function (day) {
      return React.createElement("th", {
        key: day,
        className: CSSPrefix_1.lsgPre + "inputdatepicker-th"
      }, day);
    }))), React.createElement("tbody", null, weeksOfMonth.map(function (wom, w) {
      var firstDay = wom * 7 - offsetDay;
      return firstDay > numDaysOfMonth ? undefined : React.createElement("tr", {
        key: firstDay
      }, daysOfWeek.map(function (dow, d) {
        var day = wom * 7 + dow - offsetDay;
        var isSelected = isSelectedMonth && day === value.getDate();
        var date = date_fns_1.setDate(activeDate, day);

        var isSelectable = _this.isInRange(date);

        var formattedDay = day > 0 && day <= numDaysOfMonth ? ("0" + day).substr(-2) : undefined;

        if (formattedDay) {
          return React.createElement("td", {
            className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "inputdatepicker-td", CSSPrefix_1.lsgPre + "inputdatepicker-td-filled", isSelectable && CSSPrefix_1.lsgPre + "inputdatepicker-td__selectable", date_fns_1.getDay(activeDate) === d && Math.ceil((offsetDay + date_fns_1.getDate(activeDate)) / 7 - 0.9) === w && CSSPrefix_1.lsgPre + "inputdatepicker-td__focused"]),
            onMouseDown: function onMouseDown(e) {
              return !isSelectable && _this.preventMouseDown(e);
            },
            onTouchStart: function onTouchStart(e) {
              return !isSelectable && _this.preventMouseDown(e);
            },
            onClick: isSelectable ? function () {
              return _this.onClick(activeDate.getFullYear(), activeDate.getMonth(), day);
            } : undefined,
            key: day
          }, React.createElement("div", {
            className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "inputdatepicker-day", isSelected && CSSPrefix_1.lsgPre + "inputdatepicker-day__selected"])
          }, React.createElement("div", {
            className: CSSPrefix_1.lsgPre + "inputdatepicker-day-inner"
          }, formattedDay)));
        }

        return React.createElement("td", {
          className: CSSPrefix_1.lsgPre + "inputdatepicker-td",
          key: day
        }, "\xA0");
      }));
    })))), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputdatepicker-spacer"
    }));
  };

  DateWidget.defaultProps = {
    minDate: utils_1.DateUtils.minDate,
    maxDate: utils_1.DateUtils.maxDate,
    onChange: function onChange() {
      /* empty */
    }
  };
  return DateWidget;
}(React.Component);

exports.DateWidget = DateWidget;